module.exports = __webpack_public_path__ + "static/blueprint-87dbbb693b6eb33e49289b88e4e95183.jpg";